
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Previewer from 'vux/src/components/previewer/index.vue'

import { Tab, Tabs } from 'vant'
import Scroll from '@/components/scroller'
import config from '@/config/index'
import pdf from 'vue-pdf'
import { getCategory, getNewslist, readbooklistsz, getAllArticle, getAllBook } from '@/api/youzheng.js'
import { operateCreditlist } from '@/api/user.js'
export default {
name: 'youwenhua',
directives: {
TransferDom
},
data () {
return {
baseUrl: config.baseUrl,
owner_type: config.owner_type,
categorylist: [],
newslist: [],
selected: parseInt(this.$route.params.selected),
notFirstLoad: false,
loadMoreDom: null,
pagecurent: 1,
pagesize: 20,
category: this.$route.params.category,
show: false,
imgurl: '',
imglist: [],
booklist: '',
showtab: true
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
created () {
this.getcategorylist()
},
components: {
[Tab.name]: Tab,
[Tabs.name]: Tabs,
Flexbox,
FlexboxItem,
Scroll,
XDialog,
Previewer,
pdf
},
watch: {

'$route' (to, from) {

this.fetchLink()
}
},
mounted () {
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')
this.getlist(this.category, this.pagesize, 1)
this.addIntegral()
console.log(this.selected)
},
methods: {
getinfor (type, done) {
getAllBook({
}).then(res => {
if (type === 'refresh' || type === 'search') {
this.booklist = []
this.listDom.scrollTop = 0
}
this.booklist = res.obj
done && done()
})
},
linkdetail (code,title) {
this.$router.push({ name: 'booklist', params: { code: code,name: title } })
},
fetchLink () {
this.imglist = []
this.newslist = []
this.pagecurent = 1
this.selected = parseInt(this.$route.params.selected)
this.getlist(this.$route.params.category, this.pagesize, 1)
},
logIndexChange (arg) {
},
getcategorylist () {
getCategory({
owner_type: this.$config.owner_type,
CHANNELCODE: 'ch10',
SHOWWECHAT: 1
}).then(res => {
if (res.success) {
this.categorylist = res.obj
}
})
},
gotoContent (ID) {
this.$router.push({ name: 'yzDetail', params: { type: ID } })
},
getlist (CATEGORYCODE, pagesize, pagecurent, type, done) {
if (this.selected == 0) {
this.getinfor(type, done)
this.loadMoreDom.style.display = 'none'
} else {
getNewslist({
CATEGORYCODE: CATEGORYCODE,
pageSize: pagesize,
pageCurrent: pagecurent,
CHANNELCODE: 'ch10',
owner_type: config.owner_type,
searchValue: ''
}).then(res => {
if (type === 'refresh' || type === 'search') {
this.imglist = []
this.newslist = []
this.listDom.scrollTop = 0
}
if (res.obj !== '' && res.obj.length > 0) {
res.obj.forEach(item => {
this.newslist.push(item)
if (item.mobileTitleImgURL !== null) {
this.imglist.push({
msrc: this.baseUrl + item.mobileTitleImgURL,
src: this.baseUrl + item.mobileTitleImgURL
})
}
})
}
if (res.obj.length === 0 && pagecurent == 1) {
this.loadMoreDom.style.display = 'none'
this.notFirstLoad = true
} else {
this.loadMoreDom.style.display = 'flex'
this.notFirstLoad = false
}
if (
res.obj.length === 0 ||
res.obj.length < pagesize
) {
this.loadMoreDom.innerText = '我也是有底线的～o～'
setTimeout(() => {
this.loadMoreDom.style.display = 'none'
}, 2000)
}
done && done()
})
}
},
onTab (index) {
console.log(index)





this.category = this.categorylist[index].CATEGORYCODE

this.$router.push({ name: 'youwenhua', params: { selected: index, category: this.categorylist[index].CATEGORYCODE } })
},

refresh (done, index) {
if (index != 0) {
this.pagecurent = 1
this.loadMoreDom.innerText = '加载中...'

this.getlist(this.category, this.pagesize, this.pagecurent, 'refresh', done)
} else {
}
},

loadMore (done, index) {
if (index != 0) {
this.pagecurent++
this.getlist(this.category, this.pagesize, this.pagecurent, 'more', done)
}
},
imgbig (index) {
this.$refs.previewer.show(index)
},

addIntegral (credit) {
operateCreditlist({
accountid: this.accountid,
rulecode: 'ywh_rule',
credit: 1,
owner_type: this.owner_type,
relationtype: 2,
relationid: 1,
terminaltype: 2
}).then(res => { })
}
}
}
